'use client'
import React from 'react'
import { Dialog, DialogHeader, DialogTitle, DialogTrigger } from '.'
import { Button } from '@/ui/atoms/Button'
import { TypedLocale } from 'payload'
import { RenderPopUpBlocks } from '@/ui/blocks/RenderPopUpBlocks'
import { CMSButtonPropsType } from '../CMSButton'
import { ButtonContent } from '@/ui/atoms/Button'
import dynamic from 'next/dynamic'
import { sendGAEvent } from '@next/third-parties/google'
import { trackEvent } from '@/lib/analytics/posthog'

const DynamicDialogContent = dynamic(() => import('.').then((mod) => mod.DialogContent), {
  ssr: false,
  // loading: () => <PopUpSkeleton />,
})

export type PopUpButtonProps = CMSButtonPropsType & {
  locale: TypedLocale
}

export const PopUpButton: React.FC<PopUpButtonProps> = (props) => {
  const {
    label,
    className,
    appearance,
    popupbutton,
    locale,
    size,
    showIconLeft,
    iconLeft,
    showIconRight,
    iconRight,
  } = props

  if (!popupbutton) {
    return null
  }

  const { title, layout } = popupbutton

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className={className} onClick={() => { sendGAEvent('event', 'dialogButtonClicked', { label: label, dialog: title} ); trackEvent('dialogButtonClicked', { label, dialog: title }) }} variant={appearance ?? 'primary'} size={size ?? 'md'}>
          <ButtonContent
            showIconLeft={showIconLeft}
            iconLeft={iconLeft}
            showIconRight={showIconRight}
            iconRight={iconRight}
          >
            {label}
          </ButtonContent>
        </Button>
      </DialogTrigger>
      <DynamicDialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <RenderPopUpBlocks blocks={layout ?? []} locale={locale} />
      </DynamicDialogContent>
    </Dialog>
  )
}
